import React, { useRef } from "react";
import {
  Autocomplete,
  Backdrop,
  Button,
  Stack,
  TextField,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";

import { useEffect, useState, useMemo } from "react";
import { Link, useHistory } from "react-router-dom";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import { createTheme, ThemeProvider } from "@mui/material/styles";

import { toast } from "react-toastify";
import axios from "axios";
import FlightIcon from "@mui/icons-material/Flight";
import { ToastContainer } from "react-toastify/dist";

// tablle imports

import {
  useAsyncDebounce,
  useBlockLayout,
  useColumnOrder,
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";

import Loader from "../../../components/Loader";
import ColumnFilter from "../UserManagement/Tables/ColumnFilter";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import Swal from "sweetalert2";

export default function ViewTransfers() {
  const [open, setOpen] = useState(false);
  const [travelDetails, setTravelDetails] = useState(undefined);
  const [buttonDisable, setbuttonDisable] = useState(false);
  const [employeeName, setemployeeName] = useState({
    associate: [],
    manager: [],
  });
  const [employeeNameData, setemployeeNameData] = useState({
    associate: null,
    manager: null,
  });
  const [value, setValue] = React.useState(dayjs(new Date()));
  const [valuee, setValuee] = React.useState();
  // const [state, setstate] = useState("");

  const handleChange = (newValue) => {
    setValue(newValue);
  };
  const handleChangee = (newValue) => {
    setValuee(newValue);
  };
  const [data, setData] = useState([]);

  const travelDetailsss = useRef(null);
  const travelDetailsssclose = useRef(null);
  const tabChange = useRef(null);

  const TravelModals = (cell) => {
    setTravelDetails(cell.row.original);
    travelDetailsss?.current?.click();
  };
  const tabChnagee = () => {
    tabChange?.current?.click();
  };

  const addTravel = async (e) => {
    try {
      setOpen(true);
      e.preventDefault();
      const res = await axios.post(
        `${process.env.REACT_APP_COMMON_API}/transaction/addTransferDetails`,
        {
          userid: travelDetails.userid,
          employeename: travelDetails.employeename,
          locationfrom: employeeNameData.associate.locationid,
          tocationto: employeeNameData.manager.locationid,
          startdate: value?.$d,
          //   enddate: valuee?.$d,
          updatetime: "2023-01-20T18:07:54.891+00:00",
          addedby: "1",
        }
      );

      if (res.data.statusCode == 200) {
        setOpen(false);
        await travelDetailsssclose?.current?.click();
        await setemployeeNameData(null);
        await toast.success("Transfer Details Updated", {
          theme: "colored",
          // toastid:""
        });
        Swal.fire({
          icon: "success",
          // title: "Oops...",
          text: "Transfer Details Updated",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      } else {
        setOpen(false);
        await setemployeeNameData(null);
        await travelDetailsssclose?.current?.click();
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescriptions.statusDescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      console.log(error);
      await setemployeeNameData(null);
      await travelDetailsssclose?.current?.click();
      setOpen(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something Went Wrong !! Please check your network ",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };
  const allLocations = async () => {
    try {
      setOpen(true);
      const res = await axios(
        `${process.env.REACT_APP_COMMON_API}/location/getAllLocations`
      );

      if (res.data.responseStatus.statusCode == 200) {
        if (res.data.responseStatus.statusCode == 200) {
          const ids = res.data.employeeResponse.map((o) => o.city);
          const filtered = res.data.employeeResponse.filter(
            ({ city }, index) => !ids.includes(city, index + 1)
          );
          setemployeeName({
            associate: filtered,
            manager: filtered,
          });
        }
        setOpen(false);
      } else {
        setOpen(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescriptions.statusDescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      console.log(error);
      setOpen(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something Went Wrong !! Please check your network ",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  useEffect(() => {
    allLocations();
  }, []);

  const columns = useMemo(
    () => [
      {
        Header: "S.no",

        accessor: "S.no",
        Cell: (cell) => {
          return <>{cell.row.index + 1}</>;
        },
      },
      {
        Header: "User-Id",

        accessor: "userId",
      },
      {
        Header: "Designation",

        accessor: "designationid",
        Cell: (cell) => (
          <>
            {cell.row.original.designationid == 1 ? (
              <>
                <span class="badge bg-success">Cook</span>
              </>
            ) : cell.row.original.designationid == 2 ? (
              <>
                <span class="badge bg-danger ">Driver</span>
              </>
            ) : cell.row.original.designationid == 3 ? (
              <>
                <span class="badge bg-danger ">Housekeeping Supervisor</span>
              </>
            ) : cell.row.original.designationid == 4 ? (
              <>
                <span class="badge bg-danger ">Steward</span>
              </>
            ) : cell.row.original.designationid == 5 ? (
              <>
                <span class="badge bg-danger ">Housekeeper</span>
              </>
            ) : (
              <>
                <span class="badge bg-danger ">General Manager</span>
              </>
            )}
          </>
        ),
      },
      {
        Header: "E-Mail",

        accessor: "email",
      },
      {
        Header: "Employee Name",

        accessor: "employeename",
      },
      {
        Header: "Organisation",

        accessor: "ogranisation",
        Cell: (cell) => (
          <>
            {cell.row.original.ogranisation ? (
              <>
                <span class="badge bg-success">
                  {cell.row.original.ogranisation}
                </span>
              </>
            ) : (
              <>
                <span class="badge bg-danger ">N/A</span>
              </>
            )}
          </>
        ),
      },
      {
        Header: "Payroll-Id",

        accessor: "payrollid",
      },
      {
        Header: "Role",

        accessor: "roleid",
        Cell: (cell) => (
          <>
            {cell.row.original.roleid == 1 ? (
              <>
                <span class="badge bg-success">Administrator</span>
              </>
            ) : cell.row.original.roleid == 2 ? (
              <>
                <span class="badge bg-danger ">HR Manager</span>
              </>
            ) : cell.row.original.roleid == 3 ? (
              <>
                <span class="badge bg-danger ">HR Associate</span>
              </>
            ) : cell.row.original.roleid == 4 ? (
              <>
                <span class="badge bg-danger ">OPS Head</span>
              </>
            ) : (
              <>
                <span class="badge bg-danger ">CSM</span>
              </>
            )}
          </>
        ),
      },
      {
        Header: "Action",
        Footer: "Action",
        accessor: "action",
        Cell: (cell) => {
          return (
            <div className="dropdown">
              <button
                className="btn color_1 dropdown-toggle"
                type="button"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="material-icons opacity-10 size">person</i>
              </button>
              <ul
                className="dropdown-menu"
                aria-labelledby="dropdownMenuButton1"
              >
                <li>
                  <a
                    className="dropdown-item"
                    onClick={() => {
                      TravelModals(cell);
                      tabChnagee();
                    }}
                  >
                    <FlightIcon style={{ fontSize: "17px" }} />
                    Initiate Transfer
                  </a>
                </li>
                {/* <li>
                  <a
                    className="dropdown-item"
                    onClick={() => {
                      // LeaveModal(cell);
                    }}
                  >
                    <i class="fa fa-unlock" aria-hidden="true"></i>
                    Remove Employee
                  </a>
                </li> */}
              </ul>
            </div>
          );
        },

        disableFilters: true,
      },
    ],
    []
  );

  // console.log(valuee?.$d);
  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: {
            color: "red",
          },
        },
      },
    },
    palette: {
      primary: {
        main: "#FFA500", //this overide blue color
        // light: "#fff", //overides light blue
        // dark: "#fff", //overides dark blue color
      },
    },
  });

  const defaultColumn = useMemo(() => {
    return {
      Filter: ColumnFilter,
    };
  }, []);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    // footerGroups,
    rows,
    page,
    nextPage,
    canNextPage,
    previousPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow,
    state,
    setGlobalFilter,
    selectedFlatRows,
    setColumnOrder,
    allColumns,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
      // initialState: { pageIndex: 1 }
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect
    // useColumnOrder,
    // useBlockLayout,
    // useSticky,
    // (hooks) => {
    //   hooks.visibleColumns.push((columns) => {
    //     return [
    //       {
    //         id: "selection",
    //         Header: ({ getToggleAllRowsSelectedProps }) => (
    //           <CheckBox {...getToggleAllRowsSelectedProps()} />
    //         ),
    //         Cell: ({ row }) => (
    //           <CheckBox {...row.getToggleRowSelectedProps()} />
    //         ),
    //       },
    //       ...columns,
    //     ];
    //   });
    // }
  );

  const { globalFilter, pageIndex, pageSize } = state;

  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 1000);

  const [globalSearchValue, setGlobalSearchValue] = useState(globalFilter);

  const resetValues = useRef(null);
  const nextPageRef = useRef(null);

  const employees = async () => {
    try {
      setOpen(true);
      const res = await axios(
        `${process.env.REACT_APP_COMMON_API}/employee/getAllEmployees`
      );

      // console.log(res.data);
      if (res.data.responseStatus.statusCode == 200) {
        setOpen(false);
        // const ids = res.data.response.employee.map((o) => o.employeename);
        // const filtered = res.data.response.employee.filter(
        //   ({ employeename }, index) => !ids.includes(employeename, index + 1)
        // );
        // setemployeeName({
        //   associate: filtered,
        //   manager: filtered,
        // });
        const employess = res.data.employeeResponse?.sort((a, b) =>
          a?.userid < b?.userid ? 1 : -1
        );
        setData(employess);
      } else {
        setOpen(false);
        setTimeout(async () => {
          await toast.error(res.data.responseStatus.statusDescription, {
            theme: "colored",
          });
        }, 100);
      }
    } catch (error) {
      console.log(error);
      setOpen(false);
      setTimeout(async () => {
        await toast.error("Something went wrong ! Please check your network", {
          theme: "colored",
        });
      }, 100);
    }
  };

  useEffect(() => {
    employees();
  }, []);

  return (
    <>
      {" "}
      <section class="form_card mt-5">
        <ToastContainer autoClose={5000} />

        <Backdrop
          sx={{
            transform: "translateZ(0)",
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={open}
        >
          <Loader />
        </Backdrop>

        <div className="card mb-3 mt-4">
          <div class="card-header p-3 position-relative border-0 bg-white">
            <div class="ttl_bx position-absolute d-flex mt_n4">
              <i class="fas fa-user d-block m-auto"></i>
            </div>
            <div class="d-flex justify-content-between title_8 ms_5">
              <p>View All Transfers</p>
            </div>
          </div>
          {/* <div class="d-flex align-items-center w_30 mt_n3 ms-5 me-auto">
            <i class="fas fa-envelope d-block" aria-hidden="true"></i>
            <span class="d-block w-100 text-uppercase ms-2">
              Detailed Employees
            </span>
          </div> */}
          <button
            ref={travelDetailsss}
            type="button"
            className="btn btn-primary d-none"
            data-bs-toggle="modal"
            data-bs-target="#staticBackdrop9"
          >
            Launch static backdrop modal
          </button>

          <form onSubmit={addTravel}>
            <div
              className="modal fade"
              id="staticBackdrop9"
              data-bs-backdrop="static"
              data-bs-keyboard="false"
              tabindex="-1"
              aria-labelledby="staticBackdropLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="staticBackdropLabel">
                      Transfer Employee To ?
                    </h5>
                    <button
                      type="button"
                      ref={travelDetailsssclose}
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <ThemeProvider theme={theme}>
                    <div className="modal-body">
                      <ul class="nav nav-tabs" id="myTab" role="tablist">
                        <li class="nav-item" role="presentation">
                          <button
                            ref={tabChange}
                            // class="nav-link active"
                            class="nav-link active"
                            id="home-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#home"
                            type="button"
                            role="tab"
                            aria-controls="home"
                            aria-selected="true"
                            // onClick={() => {
                            //   settabToggle(false);
                            // }}
                            // tabToggle={false}
                          >
                            New Organisation
                          </button>
                        </li>
                        <li class="nav-item" role="presentation">
                          <button
                            class="nav-link"
                            id="profile-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#profile"
                            type="button"
                            role="tab"
                            aria-controls="profile"
                            aria-selected="false"
                          >
                            New Location
                          </button>
                        </li>
                      </ul>
                      <div class="tab-content mt-3" id="myTabContent">
                        <div
                          class="tab-pane fade show active"
                          id="home"
                          role="tabpanel"
                          aria-labelledby="home-tab"
                        >
                          <div className="row">
                            <div className="col-md-6 mt-4">
                              <TextField
                                required
                                disabled
                                value={travelDetails?.employeename}
                                className="w-100"
                                label="Username"
                                name="name"
                                variant="outlined"
                                size="small"
                                type="text"
                              />
                            </div>
                            <div className="col-md-6 mt-4">
                              <TextField
                                required
                                disabled
                                value={travelDetails?.payrollid}
                                className="w-100"
                                label="Payroll-Id"
                                name="name"
                                variant="outlined"
                                size="small"
                                type="text"
                              />
                            </div>
                          </div>
                          <div className="row mt-4">
                            <div className="col-md-6">
                              <Autocomplete
                                fullWidth
                                required
                                size="small"
                                disablePortal
                                id="combo-box-demo"
                                options={employeeName?.associate}
                                getOptionLabel={(option) => `${option?.city}`}
                                value={employeeNameData?.associate}
                                onChange={(e, val) => {
                                  setemployeeNameData({
                                    ...employeeNameData,
                                    associate: val,
                                  });
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    required
                                    {...params}
                                    size="small"
                                    label="Organisation-From"
                                  />
                                )}
                              />
                            </div>
                            <div className="col-md-6">
                              <Autocomplete
                                fullWidth
                                required
                                size="small"
                                disablePortal
                                id="combo-box-demo"
                                options={employeeName?.manager}
                                getOptionLabel={(option) => `${option?.city}`}
                                value={employeeNameData?.manager}
                                onChange={(e, val) => {
                                  setemployeeNameData({
                                    ...employeeNameData,
                                    manager: val,
                                  });
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    required
                                    {...params}
                                    size="small"
                                    label="Organisation-To"
                                  />
                                )}
                              />
                            </div>
                          </div>
                          <div>
                            <div className="row mt-4">
                              <div className="col-md-6">
                                <LocalizationProvider
                                  dateAdapter={AdapterDayjs}
                                >
                                  <Stack spacing={3}>
                                    <DesktopDatePicker
                                      style={{ zIndex: "10px" }}
                                      minDate={dayjs(new Date())}
                                      label="Start Date"
                                      inputFormat="DD/MM/YYYY"
                                      value={value}
                                      onChange={handleChange}
                                      renderInput={(params) => (
                                        <TextField
                                          required
                                          size="small"
                                          {...params}
                                        />
                                      )}
                                    />
                                  </Stack>
                                </LocalizationProvider>
                              </div>
                              {/* <div className="col-md-6">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <Stack spacing={3}>
                                <DesktopDatePicker
                                  style={{ zIndex: "10px" }}
                                  label="End Date"
                                  onError={(e) => {
                                    if (e) {
                                      setbuttonDisable(true);
                                    } else {
                                      setbuttonDisable(false);
                                    }
                                  }}
                                  minDate={dayjs(value?.$d)}
                                  inputFormat="DD/MM/YYYY"
                                  value={valuee}
                                  onChange={handleChangee}
                                  renderInput={(params) => (
                                    <TextField
                                      helperText="End Date Should not be Lower than Start Date"
                                      required
                                      size="small"
                                      {...params}
                                    />
                                  )}
                                />
                              </Stack>
                            </LocalizationProvider>
                          </div> */}
                            </div>
                          </div>
                        </div>
                        <div
                          class="tab-pane fade"
                          id="profile"
                          role="tabpanel"
                          aria-labelledby="profile-tab"
                        >
                          <div className="row">
                            <div className="col-md-6 mt-4">
                              <TextField
                                required
                                disabled
                                value={travelDetails?.employeename}
                                className="w-100"
                                label="Username"
                                name="name"
                                variant="outlined"
                                size="small"
                                type="text"
                              />
                            </div>
                            <div className="col-md-6 mt-4">
                              <TextField
                                required
                                disabled
                                value={travelDetails?.payrollid}
                                className="w-100"
                                label="Payroll-Id"
                                name="name"
                                variant="outlined"
                                size="small"
                                type="text"
                              />
                            </div>
                          </div>
                          <div className="row mt-4">
                            <div className="col-md-6">
                              <Autocomplete
                                fullWidth
                                required
                                size="small"
                                disablePortal
                                id="combo-box-demo"
                                options={employeeName?.associate}
                                getOptionLabel={(option) => `${option?.city}`}
                                value={employeeNameData?.associate}
                                onChange={(e, val) => {
                                  setemployeeNameData({
                                    ...employeeNameData,
                                    associate: val,
                                  });
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    required
                                    {...params}
                                    size="small"
                                    label="Location-From"
                                  />
                                )}
                              />
                            </div>
                            <div className="col-md-6">
                              <Autocomplete
                                fullWidth
                                required
                                size="small"
                                disablePortal
                                id="combo-box-demo"
                                options={employeeName?.manager}
                                getOptionLabel={(option) => `${option?.city}`}
                                value={employeeNameData?.manager}
                                onChange={(e, val) => {
                                  setemployeeNameData({
                                    ...employeeNameData,
                                    manager: val,
                                  });
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    required
                                    {...params}
                                    size="small"
                                    label="Location-To"
                                  />
                                )}
                              />
                            </div>
                          </div>
                          <div>
                            <div className="row mt-4">
                              <div className="col-md-6">
                                <LocalizationProvider
                                  dateAdapter={AdapterDayjs}
                                >
                                  <Stack spacing={3}>
                                    <DesktopDatePicker
                                      style={{ zIndex: "10px" }}
                                      minDate={dayjs(new Date())}
                                      label="Start Date"
                                      inputFormat="DD/MM/YYYY"
                                      value={value}
                                      onChange={handleChange}
                                      renderInput={(params) => (
                                        <TextField
                                          required
                                          size="small"
                                          {...params}
                                        />
                                      )}
                                    />
                                  </Stack>
                                </LocalizationProvider>
                              </div>
                              {/* <div className="col-md-6">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <Stack spacing={3}>
                                <DesktopDatePicker
                                  style={{ zIndex: "10px" }}
                                  label="End Date"
                                  onError={(e) => {
                                    if (e) {
                                      setbuttonDisable(true);
                                    } else {
                                      setbuttonDisable(false);
                                    }
                                  }}
                                  minDate={dayjs(value?.$d)}
                                  inputFormat="DD/MM/YYYY"
                                  value={valuee}
                                  onChange={handleChangee}
                                  renderInput={(params) => (
                                    <TextField
                                      helperText="End Date Should not be Lower than Start Date"
                                      required
                                      size="small"
                                      {...params}
                                    />
                                  )}
                                />
                              </Stack>
                            </LocalizationProvider>
                          </div> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ThemeProvider>
                  <div className="modal-footer">
                    <Button
                      type="submit"
                      disabled={buttonDisable}
                      variant="contained"
                      sx={{ background: "#F67503" }}
                      endIcon={<SendIcon />}
                    >
                      Submit
                    </Button>
                    <Button
                      data-bs-dismiss="modal"
                      ref={resetValues}
                      onClick={() => {
                        setemployeeNameData({
                          associate: null,
                          manager: null,
                        });
                        // setValue("");
                        // setValuee("");
                      }}
                      sx={{ marginLeft: "10px", background: "#4C4234" }}
                      type="reset"
                      variant="contained"
                      endIcon={<RestartAltIcon />}
                    >
                      Cancel
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </form>

          {data.length > 0 ? (
            <div className="card-body p-4 ">
              <div className="d-flex justify-content-between my-3">
                {/* {searchIcon == true && ( */}
                <select
                  value={pageSize}
                  className="dropdown"
                  onChange={(e) => {
                    setPageSize(Number(e.target.value));
                  }}
                >
                  {[10, 25, 50].map((value, i) => {
                    return (
                      <option
                        className="dropdown-menu"
                        aria-labelledby="dropdownMenuButton1"
                        value={value}
                        key={value}
                      >
                        {" "}
                        Show {value}
                      </option>
                    );
                  })}
                </select>
                {/* )} */}

                <div>
                  {/* {allColumns.map((column) => {
                  return (
                    <div key={column.id}>
                      <label>
                        <input
                          type="checkbox"
                          {...column.getToggleHiddenProps()}
                        />
                        {column.Header}
                      </label>
                    </div>
                  );
                })} */}
                </div>
                {/* {searchIcon == true && ( */}
                <TextField
                  className="ms-4 "
                  sx={{
                    borderRadius: "4px",
                  }}
                  type="text"
                  label="Search"
                  name="Search"
                  variant="outlined"
                  // value={number}
                  size="small"
                  value={globalSearchValue || ""}
                  onChange={(e) => {
                    onChange(e.target.value);
                    setGlobalSearchValue(e.target.value);
                  }}
                />
                {/* )} */}
              </div>

              <div className="text-end">
                {/* {selectedFlatRows.length > 0 && (
                  <button
                    onClick={deletUser}
                    className="btn bg-gradient-primary m-0"
                  >
                    Delete Users
                  </button>
                )} */}

                {/* <button onClick={changeOrder}>Change Order</button> */}
              </div>
              <div className="table-responsive">
                <table
                  {...getTableProps()}
                  id="example"
                  className="table table-striped table-bordered dataTable table-sm mt-3 table-responsive"
                  // className=" table table-responsive table-striped table-bordered dataTable mt-3"
                >
                  <thead>
                    {headerGroups.map((headerGroup) => (
                      <tr {...headerGroup.getHeaderGroupProps()}>
                        {headerGroup.headers.map((column) => (
                          <th
                            {...column.getHeaderProps(
                              column.getSortByToggleProps()
                            )}
                            className="text-left width_2"
                          >
                            {column.render("Header")}
                            <span>
                              {column.isSorted
                                ? column.isSortedDesc
                                  ? "↑"
                                  : "↓"
                                : ""}
                            </span>

                            {/* <div>{column.canFilter ? column.render("Filter") : null}</div> */}
                          </th>
                        ))}
                      </tr>
                    ))}
                  </thead>
                  <tbody {...getTableBodyProps()}>
                    {/* {rows.map((row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    return (
                      <td {...cell.getCellProps()} className="text-center">
                        {cell.render("Cell")}
                      </td>
                    );
                  })}
                </tr>
              );
            })} */}

                    {page.map((row) => {
                      prepareRow(row);
                      return (
                        <tr {...row.getRowProps()}>
                          {row.cells.map((cell) => {
                            return (
                              <td
                                {...cell.getCellProps()}
                                className="text-left"
                              >
                                {cell.render("Cell")}
                              </td>
                            );
                          })}
                        </tr>
                      );
                    })}
                  </tbody>
                  {/* <tfoot>
            {footerGroups.map((footerGroup) => (
              <tr {...footerGroup.getFooterGroupProps()}>
                {footerGroup.headers.map((column) => (
                  <td className="text-center" {...column.getFooterProps}>
                    {column.render("Footer")}
                  </td>
                ))}
              </tr>
            ))}
          </tfoot> */}
                </table>
              </div>
              <div className="d-flex justify-content-between align-items-center mt-3">
                <div>
                  <span>
                    Page:
                    <strong>
                      {pageIndex + 1} of {pageOptions.length}
                    </strong>
                  </span>

                  <span>
                    Go to Page :{""}
                    <input
                      type="number"
                      // defaultValue={pageIndex + 1}
                      value={pageIndex + 1}
                      onChange={(e) => {
                        const pageNumber = e.target.value
                          ? Number(e.target.value) - 1
                          : 0;
                        gotoPage(pageNumber);
                      }}
                      style={{ width: "50px" }}
                    />
                  </span>
                </div>

                <div id="Nikhil">
                  <button
                    className="btn btn_primary m-0 ms-2"
                    type="button"
                    style={{
                      background: "#4C4234",
                    }}
                    disabled={!canPreviousPage}
                    onClick={() => {
                      previousPage();
                    }}
                  >
                    Prev
                  </button>

                  <button
                    className="btn btn_primary m-0 ms-2"
                    type="button"
                    style={{
                      background: "#F67503",
                    }}
                    disabled={!canNextPage}
                    onClick={() => {
                      nextPage();
                    }}
                  >
                    Next
                  </button>
                </div>
                {/* <div className="text-end mt-2">
                  <p className="link-info" style={{ fontSize: "12px" }}>
                    {" "}
                    List of Accounts. Wannt to Add Account !!
                  </p>
                  <Link
                    to="/dashboard/AddAccount"
                    style={{ color: "#63B7E6", marginLeft: "30px" }}
                  >
                    <button className="btn btn-danger">Click here !!!</button>
                  </Link>
                </div> */}
              </div>
            </div>
          ) : (
            <div className="card-body">
              <div>
                <h5 style={{ textAlign: "center" }}>No Data Available</h5>
              </div>
            </div>
          )}

          <div className="text-end me-4">
            <p> Add Transfer </p>
            <Link className="primary" to="/dashboard/InitiateTransfer">
              <p style={{ color: "#F47C03" }}>Click here !!</p>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
